import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import Popup from '../Popup/index';
import LoginForm from './LoginForm';
import GuestForm from './GuestForm';
import RegisterForm from './RegisterForm';
import RequestSMSForm from './RequestSMSForm';
import CodeInputForm from './CodeInputForm';
import ReceivePasswordForm from './ReceivePasswordForm';

import Registry from '../../../registry/index';
import AnonymousSession from '../../../anonymousSession';

//import { VIDEO_WINDOW_CLOSE } from '../../../constants/streaming';

function HeaderGeneral() {
    //let chatInterface = Registry.get('chatInterface');

    return (
        <div className="header">
            <span>BobTV</span>
        </div>
    );
}

import {KEYCODE_ESCAPE} from '../Popup';

class AnonymousLoginPopup extends Popup {

    constructor(props) {
        super(props);

        this.showOverlay = true;
        this.userClosable = false;
        //this.allowReopenPopup = false;
        this.afterClosePositionReset = false;

        this.anonymousSession = new AnonymousSession(() => {});

        let chatInterface = Registry.get('chatInterface');

        let currentTab = 2;
        if(!chatInterface.getUid()) {
            if(this.anonymousSession.remaining <= 0 || window.__login_data.personal == '1') {
                currentTab = 0;
            }
        } else {
            if(!chatInterface.isActivated()) {
                currentTab = 4;
            }
        }

        this.state = {
            inactiveEmail: '',
            tabIndex: currentTab,
            closeable: chatInterface.isLoggedIn(),
            activationOnly: chatInterface.getUid() > 0 && chatInterface.isActivated(),
            visibility: 'hidden',
            personal: window.__login_data.personal ? Number(window.__login_data.personal) : 0
        };

        this.switchTab = this.switchTab.bind(this);

    }

    startAnonymousSession() {
        let thisPopup = this;
        let chatInterface = Registry.get('chatInterface');

        let onAnonymousSessionExpire = function () {
            let { visibility } = thisPopup.state;

            chatInterface.logout();
            thisPopup.switchTab(0);
            visibility !== 'shown' ? thisPopup.open() : false;
        };
        this.anonymousSession.start(onAnonymousSessionExpire);
    }

    switchTab(tabIndex) {
        this.setState({tabIndex});
    }

    setInactiveEmail(inactiveEmail) {
        this.setState({inactiveEmail});
    }

    componentDidMount() {
        super.componentDidMount();
        this._ref.focus();
    }

    componentWillUpdate(nextProps, nextState) {
        let { tabIndex } = nextState;

        let chatInterface = Registry.get('chatInterface');
        let closeable = chatInterface.isLoggedIn();
        let activationOnly = chatInterface.getUid() > 0 && chatInterface.isActivated();

        if(this.state.closeable !== closeable || this.state.activationOnly !== activationOnly || (tabIndex >= 0 && this.state.tabIndex !== tabIndex)) {
            this.setState({
                closeable: closeable,
                activationOnly: activationOnly,
                tabIndex: tabIndex
            });
        }

    }


    _onKeyDown(event) {
        //console.log("onKeyDown 2: " + event.keyCode);
        if (this.state.closeable && event.keyCode == KEYCODE_ESCAPE) {
            event.preventDefault();
            this.close();
        }
    }

    render() {
        let lang = Registry.get('locale');

        let className = 'popup popup-login-anonymous ' + this.state.visibility;

        let {
            tabIndex,
            inactiveEmail,
            closeable,
            activationOnly,
            personal
        } = this.state;

        let showTabList = tabIndex !== 0 && tabIndex !== 1 && tabIndex !== 2 ? 'hidden' : '';

        let roomDescription = window.roomDescription ? window.roomDescription : '';

        let currentUser = this.props.currentUser;

        return (
            <div className={className} ref={(ref) => this._ref = ref} onKeyDown={(e) => this._onKeyDown(e)}>
                <HeaderGeneral />
                {this.state.closeable ? <a className="close-btn" onClick={() => this.close()}></a> : null}
                <Tabs selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.setState({ tabIndex })}>
                    <TabList className={`menu ${showTabList}`}>
                        <Tab tabIndex="0">{lang.login}</Tab>
                        <Tab tabIndex="1">{lang.register}</Tab>
                        {!closeable && !personal ? <Tab tabIndex="2">{lang.guest}</Tab> : <Tab hidden />}
                        <Tab hidden />
                        {inactiveEmail ? <Tab tabIndex="4">{lang.activation}</Tab> : <Tab hidden />}
                        <Tab hidden />
                        <Tab hidden />
                    </TabList>

                    <TabPanel tabIndex="0">
                        <LoginForm close={() => this.close()} switchTab={this.switchTab} />
                        <div className="room-description" dangerouslySetInnerHTML={{__html: roomDescription}} />
                    </TabPanel>
                    <TabPanel tabIndex="1">
                        <RegisterForm 
                            close={() => this.close()} 
                            switchTab={this.switchTab} 
                            setInactiveEmail={(email) => this.setInactiveEmail(email)} 
                        />
                    </TabPanel>
                    <TabPanel tabIndex="2">
                        <GuestForm 
                            close={() => this.close()} 
                            switchTab={this.switchTab}
                            onLoginSuccess={() => this.startAnonymousSession()}
                            anonymousSession={this.anonymousSession}
                        />
                        <div className="room-description" dangerouslySetInnerHTML={{__html: roomDescription}} />
                    </TabPanel>
                    <TabPanel tabIndex="3">
                        <ReceivePasswordForm close={() => this.close()} switchTab={this.switchTab} />
                    </TabPanel>
                    <TabPanel tabIndex="4">
                        <CodeInputForm
                            close={() => this.close()} 
                            switchTab={this.switchTab}
                            inactiveEmail={inactiveEmail}
                            activationOnly={activationOnly}
                        />
                    </TabPanel>
                    <TabPanel tabIndex="5">
                        <RequestSMSForm
                            close={() => this.close()}
                            switchTab={this.switchTab}
                            activationOnly={activationOnly}
                        />
                    </TabPanel>
                    <TabPanel>
                        <div style={{color: 'white', fontWeight: 'bold', marginTop: '5px'}}>{lang.ageverif}</div>
                        <LoginForm close={() => this.close()} switchTab={this.switchTab} currentUser={currentUser}/>
                        <div className="room-description" dangerouslySetInnerHTML={{__html: roomDescription}} />
                    </TabPanel>
                </Tabs>
            </div>
        );
    }

}

const mapStateToProps = (state) => ({
    currentUser: state.currentUser
});

var AnonymousLoginPopup_connect = connect(mapStateToProps, null, null, {forwardRef: true})(AnonymousLoginPopup);

AnonymousLoginPopup_connect.generateKey = function() { return 'anonymous-required-popup'; };

AnonymousLoginPopup_connect.mount = function(props) {
    let id = AnonymousLoginPopup_connect.generateKey();
    if (!Popup.popups[id]) {
        Popup.mount(AnonymousLoginPopup_connect, props, () => {});
    }
};

AnonymousLoginPopup_connect.open = function(props) {
    let id = AnonymousLoginPopup_connect.generateKey();
    
    if (!Popup.popups[id]) {
        Popup.mount(AnonymousLoginPopup_connect, props, () => Popup.popups[id].open());
    } else {
        Popup.popups[id].open();
    }
};

AnonymousLoginPopup_connect.openAndSwitchTab = function(tabIndex) {
    let id = AnonymousLoginPopup_connect.generateKey();

    if (Popup.popups[id]) {
        Popup.popups[id].switchTab(tabIndex);
        Popup.popups[id].open();
    }
};

export default AnonymousLoginPopup_connect;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/AnonymousLoginPopup/index.js